import React from 'react'
import { Helmet } from 'react-helmet-async'
import { ManageAccountsLayout } from '../../layouts'

const ManageAccountsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Manage Accounts</title>
      <meta name="description" content="Manage Accounts page" />
    </Helmet>
    <ManageAccountsLayout />
  </React.Fragment>
)

export default ManageAccountsPage
